import { render } from "./DyBackground.vue?vue&type=template&id=20843c36&scoped=true"
import script from "./DyBackground.vue?vue&type=script&lang=js"
export * from "./DyBackground.vue?vue&type=script&lang=js"

import "./DyBackground.vue?vue&type=style&index=0&id=20843c36&scoped=true&lang=css"

import exportComponent from "D:\\vue\\rs459\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20843c36"]])

export default __exports__